import React from 'react';

export type reviewSetCardStateItem = {
  mainText: string;
  subText: string;
  progressBar: boolean;
  button: boolean;
  buttontext: string;
};

export type ReviewSetStateType =
  | 'no_actions'
  | 'inbox'
  | 'inbox_continue'
  | 'sample'
  | 'sample_continue';

export const defaultReviewer = { value: 'me', label: 'Reviewer (Me)' };

// eslint-disable-next-line import/prefer-default-export
export const reviewSetCardState: Record<ReviewSetStateType, reviewSetCardStateItem> = {
  no_actions: {
    mainText: 'No Actions Needed',
    subText: 'Good for now',
    progressBar: false,
    button: false,
    buttontext: '',
  },
  inbox: {
    mainText: 'Review All',
    subText: '{count} Message',
    progressBar: false,
    button: true,
    buttontext: 'Start',
  },
  inbox_continue: {
    mainText: 'Review In Progress',
    subText: '{count} Message',
    progressBar: false,
    button: true,
    buttontext: 'Continue',
  },
  sample: {
    mainText: 'Begin Assignment',
    subText: 'Review {count} Message',
    progressBar: false,
    button: true,
    buttontext: 'Start',
  },
  sample_continue: {
    mainText: 'Assignment In Progress',
    subText: '',
    progressBar: true,
    button: true,
    buttontext: 'Continue',
  },
};

// Create review set modal

export const reviewTypeOptions = [
  {
    value: 'inbox-0',
    label: 'Shared Inbox',

    text: 'For messages that need to be reviewed quickly after being flagged. There is no fixed assignment size.',
  },
  {
    value: 'assignment',
    label: 'Assignments',
    text: 'Break up messages into fixed assignment sizes that are either created immediately or on a periodic basis.',
  },
];

export const reviewSortOptions = [
  {
    value: 'newest',
    label: 'Newest',
  },
  {
    value: 'oldest',
    label: 'Oldest',
  },
];

export const reviewPriorityOptions = [
  {
    value: 'low',
    label: 'Low',
  },
  {
    value: 'medium',
    label: 'Medium',
  },
  {
    value: 'high',
    label: 'High',
  },
];

export const privateOptions = [
  {
    value: 'modeler',
    label: 'Internal',
  },
  {
    value: 'human',
    label: 'External',
  },
];

export const reviewCadenceOptions = [
  {
    value: 'immediately',
    label: 'Immediately',
  },
  {
    value: 'weekly',
    label: 'Weekly',
  },
  {
    value: 'biweekly',
    label: 'Biweekly',
  },
  {
    value: 'monthly',
    label: 'Monthly',
  },
];

export const REVIEW_SET_INBOX_ICON = (
  <svg width="100%" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M48 22.4234L39.8465 9H10.1659L2 22.4234V40.3958H48V22.4234Z"
      fill="white"
      stroke="black"
      strokeWidth="2.69"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.2434 22.4233H34.255C34.255 27.5316 30.1161 31.6705 25.0078 31.6705C19.8994 31.6705 15.7605 27.5316 15.7605 22.4233H3.28174"
      stroke="black"
      strokeWidth="2.69"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const REVIEW_SET_SAMPLE_ICON = (
  <svg width="100%" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M48 12.6419V45.872H2V4H18.8722L20.6083 8.07661H43.4476C45.9681 8.07661 48 10.1213 48 12.6419Z"
      fill="white"
      stroke="black"
      strokeWidth="2.69"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48 45.872H2V4H18.8722L23.3861 14.5966H48V45.872Z"
      stroke="black"
      strokeWidth="2.69"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.6068 8.07666H43.4331C45.9537 8.07666 47.9984 10.1214 47.9984 12.6419V14.5966"
      stroke="black"
      strokeWidth="2.69"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const REVIEW_SET_PLAY_ICON = (colorClass = ''): JSX.Element => (
  <svg
    width="100%"
    viewBox="0 0 20 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-${colorClass}`}
  >
    <path
      d="M18.9136 10.8253L3.16102 0.341064C1.81761 -0.554524 0 0.420076 0 2.02696V22.969C0 24.6022 1.81766 25.5505 3.16102 24.6549L18.9136 14.1707C20.099 13.4067 20.099 11.6155 18.9136 10.8252V10.8253Z"
      fill="currentColor"
    />
  </svg>
);

export const SAVED_SEARCH_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
    <path
      d="M48 12.6419V45.872H2V4H18.8722L20.6083 8.07661H43.4476C45.9681 8.07661 48 10.1213 48 12.6419V12.6419Z"
      fill="white"
      stroke="black"
      strokeWidth="2.69"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48 45.872H2V4H18.8722L23.3861 14.5966H48V45.872Z"
      stroke="black"
      strokeWidth="2.69"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.6068 8.07666H43.4331C45.9537 8.07666 47.9984 10.1214 47.9984 12.6419V14.5966"
      stroke="black"
      strokeWidth="2.69"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.4745 35.9489C27.6025 35.9489 30.9489 32.6025 30.9489 28.4745C30.9489 24.3464 27.6025 21 23.4745 21C19.3464 21 16 24.3464 16 28.4745C16 32.6025 19.3464 35.9489 23.4745 35.9489Z"
      stroke="black"
      strokeWidth="2.68"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.0003 40.1957L28.1266 34.3285"
      stroke="black"
      strokeWidth="2.68"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const REVIEW_SET_EXPLORE_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="w-8 h-8"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
    />
  </svg>
);

export const REVIEW_SET_CLOCK_ICON = (
  <svg width="100%" viewBox="0 0 37 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 21.9036C0 31.8844 8.11522 40 18.0964 40C28.0775 40 36.1927 31.8848 36.1927 21.9036C36.1927 12.2501 28.5869 4.36523 19.0582 3.85589V1.92329H21.9045C22.4334 1.92329 22.8661 1.4906 22.8661 0.961645C22.8661 0.432691 22.4334 0 21.9045 0H14.2893C13.7603 0 13.3276 0.432691 13.3276 0.961645C13.3276 1.4906 13.7603 1.92329 14.2893 1.92329H17.1349V3.85589C7.6058 4.36553 0.000330746 12.2501 0.000330746 21.9036H0ZM18.0964 5.73089C27.0098 5.73089 34.2691 12.9807 34.2691 21.9036C34.2691 30.827 27.0093 38.0764 18.0964 38.0764C9.18343 38.0764 1.92362 30.8169 1.92362 21.9036C1.92362 12.9902 9.18343 5.73089 18.0964 5.73089Z"
      fill="black"
    />
    <path
      d="M12.3845 22.8653H18.0961C18.6251 22.8653 19.0577 22.4326 19.0577 21.9037V12.3845C19.0577 11.8555 18.6251 11.4229 18.0961 11.4229C17.5671 11.4229 17.1345 11.8555 17.1345 12.3845V20.9419H12.3845C11.8555 20.9419 11.4229 21.3746 11.4229 21.9035C11.4232 22.4325 11.8559 22.8652 12.3845 22.8652V22.8653Z"
      fill="black"
    />
    <path
      d="M7.29784 32.6442C7.3075 32.6538 7.3075 32.6732 7.32682 32.6825C7.34613 32.6922 7.35579 32.7018 7.36513 32.7115C10.1248 35.4518 13.9131 37.1536 18.1058 37.1536C22.2981 37.1536 26.0864 35.4518 28.8464 32.7115C28.856 32.7018 28.8753 32.7018 28.8847 32.6825C28.8943 32.6632 28.904 32.6535 28.9137 32.6442C31.654 29.8845 33.3558 26.0962 33.3558 21.9036C33.3558 17.7209 31.6633 13.9229 28.923 11.1728C28.9133 11.1632 28.9037 11.1439 28.894 11.1345C28.8843 11.1249 28.865 11.1152 28.8557 11.1055C26.077 8.36484 22.279 6.66309 18.0961 6.66309C13.9132 6.66309 10.1155 8.35552 7.36538 11.0959C7.35572 11.1056 7.3364 11.1152 7.32706 11.1249C7.31741 11.1345 7.30775 11.1539 7.29809 11.1632C4.55771 13.9228 2.86528 17.7112 2.86528 21.8939C2.85562 26.0862 4.55771 29.8842 7.29809 32.6436L7.29784 32.6442ZM8.03799 13.2019L8.66288 13.8268C8.85508 14.019 9.09557 14.1056 9.34572 14.1056C9.59588 14.1056 9.83604 14.0094 10.0286 13.8268C10.4036 13.4518 10.4036 12.8462 10.0286 12.4711L9.40368 11.8463C11.5095 10.0192 14.1923 8.84644 17.1441 8.63487V9.52926C17.1441 10.0582 17.5768 10.4909 18.1058 10.4909C18.6347 10.4909 19.0674 10.0582 19.0674 9.52926V8.63487C22.0193 8.84639 24.6924 10.0196 26.8079 11.8463L26.183 12.4711C25.808 12.8462 25.808 13.4517 26.183 13.8268C26.3752 14.019 26.6157 14.1056 26.8659 14.1056C27.116 14.1056 27.3562 14.0094 27.5487 13.8268L28.1736 13.2019C30.0006 15.3078 31.1734 17.9906 31.385 20.9424H30.4906C29.9616 20.9424 29.5289 21.3751 29.5289 21.9041C29.5289 22.433 29.9616 22.8657 30.4906 22.8657H31.385C31.1735 25.8176 30.0003 28.4907 28.1736 30.6062L27.5487 29.9813C27.1736 29.6062 26.5681 29.6062 26.193 29.9813C25.818 30.3563 25.818 30.9619 26.193 31.337L26.8179 31.9618C24.7121 33.7889 22.0293 34.9617 19.0774 35.1732V34.2788C19.0774 33.7499 18.6448 33.3172 18.1158 33.3172C17.5868 33.3172 17.1542 33.7499 17.1542 34.2788V35.1732C14.2023 34.9617 11.5292 33.7885 9.41368 31.9618L10.0386 31.337C10.4136 30.9619 10.4136 30.3564 10.0386 29.9813C9.66351 29.6062 9.05797 29.6062 8.68289 29.9813L8.058 30.6062C6.23097 28.5003 5.05818 25.8176 4.84661 22.8657H5.741C6.26996 22.8657 6.70265 22.433 6.70265 21.9041C6.70265 21.3751 6.26996 20.9424 5.741 20.9424H4.82667C5.03818 17.9906 6.21136 15.3174 8.03806 13.2019H8.03799Z"
      fill="black"
    />
  </svg>
);
export const REVIEW_SET_CHECK_ICON = (
  <svg width="100%" viewBox="0 0 40 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M37.6595 15.7163C36.3608 15.7163 35.3221 16.7553 35.3221 18.0537V36.5373H4.67478V4.93764H25.2795C26.5782 4.93764 27.6168 3.89868 27.6168 2.60029C27.6168 1.3016 26.5347 0.262939 25.2363 0.262939H2.33735C1.03866 0.262939 0 1.30191 0 2.60029V38.8749C0 40.1736 1.03897 41.2123 2.33735 41.2123H37.6597C38.9584 41.2123 39.997 40.1733 39.997 38.8749V18.0971C39.997 16.7553 38.9583 15.7162 37.6597 15.7162L37.6595 15.7163Z"
      fill="#007656"
    />
    <path
      d="M14.6302 16.4089C13.8077 15.4134 12.3792 15.2401 11.3405 16.0626C10.3449 16.8851 10.1716 18.3136 10.9941 19.3523L17.2276 27.1007C17.6606 27.6635 18.353 27.9664 19.0456 27.9664C19.7383 27.9664 20.431 27.6632 20.8637 27.1007L39.4772 3.81221C40.2997 2.81669 40.1264 1.34469 39.1308 0.522466C38.1353 -0.300068 36.6633 -0.126718 35.8411 0.868802L19.0457 21.8631L14.6302 16.4089Z"
      fill="#007656"
    />
  </svg>
);

export const REVIEW_STARS_ICON = (
  <svg
    width="138"
    height="120"
    viewBox="0 0 138 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.955 14.4254C41.5537 12.5828 44.1605 12.5828 44.7593 14.4254L52.0301 36.8029C52.2979 37.6269 53.0658 38.1848 53.9323 38.1848H77.4613C79.3988 38.1848 80.2043 40.6641 78.6369 41.8029L59.6015 55.6329C58.9005 56.1422 58.6072 57.045 58.8749 57.869L66.1458 80.2465C66.7445 82.0891 64.6356 83.6214 63.0681 82.4826L44.0327 68.6525C43.3317 68.1432 42.3825 68.1432 41.6816 68.6525L22.6461 82.4826C21.0787 83.6214 18.9698 82.0891 19.5685 80.2465L26.8393 57.869C27.1071 57.045 26.8138 56.1422 26.1128 55.6329L7.07738 41.8029C5.50995 40.6641 6.3155 38.1848 8.25294 38.1848H31.782C32.6485 38.1848 33.4164 37.6269 33.6841 36.8029L40.955 14.4254Z"
      fill="#F8A01A"
    />
    <path
      d="M75.2405 5.8541C75.8392 4.01148 78.446 4.01148 79.0447 5.8541L90.1644 40.077C90.4321 40.9011 91.2001 41.459 92.0665 41.459H128.051C129.988 41.459 130.794 43.9382 129.226 45.077L100.114 66.2279C99.4135 66.7372 99.1201 67.64 99.3879 68.464L110.508 102.687C111.106 104.53 108.997 106.062 107.43 104.923L78.3181 83.7721C77.6172 83.2628 76.668 83.2628 75.967 83.7721L46.8553 104.923C45.2878 106.062 43.1789 104.53 43.7776 102.687L54.8973 68.464C55.165 67.64 54.8717 66.7372 54.1707 66.2279L25.059 45.077C23.4916 43.9382 24.2971 41.459 26.2346 41.459H62.2186C63.0851 41.459 63.853 40.9011 64.1208 40.077L75.2405 5.8541Z"
      fill="#FFC945"
    />
  </svg>
);

export const EXPLORE_GRAPHIC = (
  <svg width="270" height="220" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <g opacity={0.62}>
        <path
          opacity={0.62}
          d="M262.901 1.67c0 .789.684 1.431 1.543 1.431.851 0 1.549-.635 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.852 0-1.55.636-1.55 1.418h-.007Z"
          fill="#80CE9D"
        />
        <path
          opacity={0.62}
          d="M262.817 22.311c0 .79.684 1.432 1.543 1.432.851 0 1.549-.636 1.556-1.418 0-.79-.691-1.432-1.542-1.432-.852 0-1.55.636-1.55 1.418h-.007ZM262.734 42.953c0 .789.683 1.432 1.542 1.432.851 0 1.549-.636 1.549-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.549.635-1.556 1.418h.007Z"
          fill="#FF9B00"
        />
        <path
          opacity={0.62}
          d="M264.193 65.026c-.412 0-.803-.153-1.096-.419a1.39 1.39 0 0 1-.447-1.013c0-.188.042-.37.119-.545.077-.174.195-.328.335-.46.147-.133.314-.238.502-.308.189-.07.391-.105.594-.105.411 0 .802.154 1.088.42.287.265.454.628.454 1.005 0 .377-.167.74-.454 1.006a1.628 1.628 0 0 1-1.095.412v.007Z"
          fill="#80CE9D"
        />
        <path
          opacity={0.62}
          d="M262.566 84.243c0 .79.684 1.432 1.543 1.432.858 0 1.549-.636 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.55.628-1.557 1.418ZM262.482 104.891c0 .79.684 1.432 1.543 1.432.851 0 1.549-.636 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.852 0-1.55.636-1.557 1.418ZM262.398 125.533c0 .789.684 1.432 1.543 1.432.851 0 1.549-.636 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.55.635-1.557 1.418ZM262.315 146.174c0 .79.684 1.432 1.543 1.432.851 0 1.549-.635 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.852 0-1.55.629-1.557 1.418ZM262.231 166.823c0 .79.684 1.432 1.543 1.432.851 0 1.549-.635 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.859 0-1.55.636-1.557 1.418ZM247.862 1.606c0 .79.684 1.432 1.543 1.432.851 0 1.549-.635 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.852 0-1.55.636-1.55 1.418h-.007ZM247.778 22.248c0 .79.684 1.432 1.543 1.432.858 0 1.549-.636 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.55.636-1.55 1.418h-.007ZM247.694 42.89c0 .789.684 1.432 1.543 1.432.851 0 1.549-.636 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.859 0-1.55.635-1.557 1.418ZM249.153 64.963c-.412 0-.803-.153-1.096-.419a1.362 1.362 0 0 1-.328-1.558c.077-.174.196-.328.335-.46.147-.133.314-.238.503-.308.188-.07.39-.105.593-.105.202 0 .405.035.593.112.189.07.356.175.503.307a1.356 1.356 0 0 1 .453 1.006c0 .377-.167.74-.453 1.006a1.63 1.63 0 0 1-1.096.412l-.007.007ZM247.527 84.18c0 .79.684 1.432 1.543 1.432.851 0 1.549-.629 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.55.628-1.55 1.418h-.007Z"
          fill="#FF9B00"
        />
        <path
          opacity={0.62}
          d="M247.444 104.829c0 .789.683 1.432 1.542 1.432.851 0 1.549-.636 1.549-1.418 0-.79-.684-1.432-1.542-1.432-.859 0-1.549.635-1.556 1.418h.007Z"
          fill="#80CE9D"
        />
        <path
          opacity={0.62}
          d="M247.359 125.47c0 .79.684 1.432 1.543 1.432.858 0 1.549-.635 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.852 0-1.55.636-1.557 1.418ZM247.269 146.112c0 .789.683 1.432 1.542 1.432.858 0 1.549-.636 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.549.629-1.556 1.418Z"
          fill="#FF9B00"
        />
        <path
          opacity={0.62}
          d="M247.185 166.76c0 .79.683 1.432 1.542 1.432.851 0 1.549-.635 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.852 0-1.549.636-1.556 1.418Z"
          fill="#80CE9D"
        />
        <path
          opacity={0.62}
          d="M232.816 1.544c0 .79.684 1.432 1.542 1.432.851 0 1.549-.636 1.549-1.418 0-.79-.684-1.432-1.542-1.432-.859 0-1.549.636-1.556 1.418h.007Z"
          fill="#FF9B00"
        />
        <path
          opacity={0.62}
          d="M232.731 22.185c0 .79.684 1.432 1.543 1.432.858 0 1.549-.636 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.55.636-1.55 1.418h-.007ZM43.995 4.785c0 .79.684 1.432 1.542 1.432.852 0 1.55-.636 1.55-1.418 0-.79-.684-1.432-1.543-1.432-.851 0-1.549.635-1.549 1.418Z"
          fill="#80CE9D"
        />
        <path
          opacity={0.62}
          d="M232.647 42.827c0 .789.684 1.432 1.543 1.432.851 0 1.549-.636 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.55.635-1.557 1.418ZM234.107 64.908c-.412 0-.803-.154-1.096-.42a1.39 1.39 0 0 1-.447-1.012c0-.378.168-.74.461-1.006a1.628 1.628 0 0 1 1.096-.412c.202 0 .405.035.593.111.188.07.356.175.502.308.147.133.259.293.335.46.077.175.119.357.119.546 0 .377-.167.74-.454 1.006a1.613 1.613 0 0 1-1.095.412l-.014.007ZM232.48 84.117c0 .79.684 1.432 1.543 1.432.858 0 1.549-.635 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.55.629-1.557 1.418ZM232.396 104.766c0 .789.684 1.432 1.543 1.432.858 0 1.549-.629 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.859 0-1.55.635-1.557 1.418Z"
          fill="#FF9B00"
        />
        <path
          opacity={0.62}
          d="M232.312 125.407c0 .79.684 1.432 1.543 1.432.851 0 1.549-.635 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.852 0-1.55.636-1.55 1.418h-.007Z"
          fill="#80CE9D"
        />
        <path
          opacity={0.62}
          d="M232.229 146.049c0 .789.684 1.432 1.543 1.432.851 0 1.549-.636 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.852 0-1.55.636-1.55 1.418h-.007ZM232.146 166.697c0 .79.684 1.432 1.542 1.432.851 0 1.549-.628 1.549-1.418 0-.789-.684-1.432-1.542-1.432-.851 0-1.549.629-1.556 1.418h.007ZM217.776 1.481c0 .79.683 1.432 1.542 1.432.851 0 1.549-.636 1.549-1.418 0-.79-.684-1.432-1.542-1.432-.859 0-1.549.636-1.556 1.418h.007ZM217.693 22.123c0 .789.683 1.432 1.542 1.432.851 0 1.549-.636 1.549-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.549.635-1.556 1.418h.007Z"
          fill="#FF9B00"
        />
        <path
          opacity={0.62}
          d="M217.608 42.771c0 .79.684 1.432 1.543 1.432.858 0 1.549-.636 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.55.636-1.557 1.418ZM28.872 25.37c0 .79.684 1.433 1.542 1.433.852 0 1.55-.636 1.55-1.418 0-.79-.684-1.432-1.543-1.432-.851 0-1.549.635-1.549 1.418Z"
          fill="#80CE9D"
        />
        <path
          opacity={0.62}
          d="M219.074 64.845c-.202 0-.405-.042-.593-.112a1.473 1.473 0 0 1-.496-.315 1.414 1.414 0 0 1-.334-.46 1.228 1.228 0 0 1-.112-.545c0-.378.167-.74.453-1.006a1.625 1.625 0 0 1 1.089-.412c.203 0 .405.035.593.111.189.07.356.175.503.308.139.133.258.293.335.46.077.175.118.357.118.546 0 .377-.167.74-.453 1.005a1.628 1.628 0 0 1-1.096.413l-.007.007Z"
          fill="#FF9B00"
        />
        <path
          opacity={0.62}
          d="M217.441 84.054c0 .79.684 1.432 1.543 1.432.851 0 1.549-.635 1.556-1.418.007-.782-.684-1.432-1.542-1.432-.852 0-1.55.636-1.557 1.418Z"
          fill="#80CE9D"
        />
        <path
          opacity={0.62}
          d="M217.358 104.703c0 .789.683 1.432 1.542 1.432.858 0 1.549-.629 1.549-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.549.628-1.556 1.418h.007ZM217.273 125.344c0 .79.684 1.432 1.543 1.432.851 0 1.549-.635 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.852 0-1.55.636-1.55 1.418h-.007ZM217.189 145.986c0 .789.684 1.432 1.543 1.432.858 0 1.549-.636 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.859 0-1.55.636-1.557 1.418ZM220.204 166.648c-.007.776-.67 1.404-1.507 1.425h-.049c-.419 0-.789-.16-1.068-.412a1.36 1.36 0 0 1-.475-1.02c.007-.789.698-1.425 1.557-1.425h.035c.474.007.893.217 1.165.531.216.245.342.559.342.894v.007ZM0 40.46c0 .788.684 1.431 1.542 1.431.852 0 1.55-.636 1.55-1.418 0-.79-.684-1.432-1.543-1.432C.698 39.034 0 39.67 0 40.46ZM202.736 1.418c0 .79.684 1.432 1.543 1.432.851 0 1.549-.636 1.549-1.418 0-.79-.684-1.432-1.542-1.432-.859 0-1.55.636-1.557 1.418h.007ZM202.652 22.067c0 .789.684 1.431 1.543 1.431.851 0 1.549-.635 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.859 0-1.55.636-1.557 1.419ZM202.569 42.708c0 .79.684 1.432 1.543 1.432.858 0 1.549-.636 1.549-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.55.636-1.55 1.418ZM204.021 64.782c-.412 0-.803-.154-1.096-.42a1.362 1.362 0 0 1-.328-1.557c.077-.175.196-.328.335-.461.147-.133.314-.238.503-.308.188-.07.391-.104.593-.104.412 0 .803.153 1.089.419a1.34 1.34 0 0 1 .328 1.55 1.36 1.36 0 0 1-.335.462 1.549 1.549 0 0 1-.503.307c-.188.07-.391.105-.593.105l.007.007ZM202.395 83.998c0 .79.684 1.432 1.542 1.432.851 0 1.549-.636 1.549-1.418 0-.79-.684-1.432-1.542-1.432-.851 0-1.549.636-1.556 1.418h.007ZM202.311 104.64c0 .789.684 1.432 1.542 1.432.851 0 1.549-.629 1.549-1.418 0-.79-.684-1.432-1.542-1.432s-1.549.628-1.556 1.418h.007ZM202.227 125.289c0 .789.684 1.432 1.542 1.432.851 0 1.549-.629 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.549.635-1.549 1.418h-.007Z"
          fill="#FF9B00"
        />
        <path
          opacity={0.62}
          d="M202.144 145.93c0 .79.683 1.432 1.542 1.432.858 0 1.549-.635 1.556-1.418 0-.789-.684-1.432-1.542-1.432-.852 0-1.549.636-1.556 1.418ZM202.06 166.579c0 .789.683 1.432 1.542 1.432.851 0 1.549-.636 1.556-1.418 0-.79-.684-1.432-1.542-1.432-.852 0-1.549.635-1.549 1.418h-.007Z"
          fill="#80CE9D"
        />
      </g>
      <g filter="url(#b)">
        <path
          d="M234.413 144.756a50.247 50.247 0 0 1-1.046 2.676 48.94 48.94 0 0 1-6.623 11.26c-1.843 2.333-4.153 4.701-6.881 7.062-.377.336-.768.664-1.166.999-.363.301-.74.608-1.117.908-3.056 2.459-6.546 4.904-10.398 7.3a121.109 121.109 0 0 1-3.28 1.984c-34.26 20.069-93.126 36.037-135.949 25.81-16.77-4.009-31.077-12.035-40.477-25.405a57.49 57.49 0 0 1-3.566-5.77c-5.535-10.247-7.789-18.588-7.789-25.846 0-10.673 4.871-19.028 11.355-27.731 3.329-4.471 7.083-9.039 10.824-14.055a152.29 152.29 0 0 0 2.045-2.794 134.467 134.467 0 0 0 3.803-5.588c.586-.915 1.173-1.844 1.745-2.794a101.083 101.083 0 0 0 3.127-5.588 80.01 80.01 0 0 0 1.395-2.794 89.34 89.34 0 0 0 2.68-6.175c.377-1.942.81-3.842 1.312-5.7.37-1.419.782-2.816 1.222-4.192 2.121-6.615 4.983-12.671 8.458-18.161a.7.7 0 0 1 .077-.12C96.232-.557 179.74-3.233 210.832 46.85a282.655 282.655 0 0 1 1.954 3.193 261.166 261.166 0 0 1 6.839 12.042c.314.594.628 1.18.928 1.768 18.746 35.974 20.449 62.595 13.86 80.903Z"
          fill="#45D09C"
        />
      </g>
      <path d="M218.69 50.036H27.469v114.566H218.69V50.036Z" fill="#fff" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.697 50.043v116.71c-.363.301-.74.608-1.117.909-3.056 2.458-6.546 4.903-10.398 7.299a121.109 121.109 0 0 1-3.28 1.984c-34.26 20.069-93.126 36.037-135.949 25.811-16.77-4.01-31.077-12.036-40.477-25.406v-76.719c1.954-1.607 3.922-3.284 5.848-5.065a83.871 83.871 0 0 0 2.91-2.794 68.944 68.944 0 0 0 4.976-5.588 61.73 61.73 0 0 0 2.087-2.794 53.53 53.53 0 0 0 6.26-11.784c.014-.028.02-.063.035-.091.53-1.39 1.04-2.787 1.535-4.192 1.787-5.043 3.385-10.114 4.969-15.15.321-1.007.635-2.012.956-3.011.007-.042.021-.077.035-.119h161.61Z"
        fill="#fff"
      />
      <path
        d="M67.953 50.162v152.594c-16.77-4.01-31.077-12.036-40.477-25.406V50.162h40.477Z"
        fill="#002A28"
      />
      <path d="M207.524 77.404H76.321v7.684h131.203v-7.684Z" fill="#D6D6D6" />
      <path
        d="M207.182 85.438v89.523a121.109 121.109 0 0 1-3.28 1.984H76.677V85.438h130.505Z"
        stroke="#D6D6D6"
      />
      <path
        d="M78.429 61.736v1.139h3.057v-1.139h-3.057Zm.112 2.613v-3.996h3.335v-1.18h-4.794v6.356h4.913v-1.18h-3.454Zm7.293-1.313 1.814-2.39h-1.507l-1.061 1.426-1.033-1.425h-1.584l1.814 2.417-1.877 2.465h1.542l1.103-1.501 1.075 1.501h1.605l-1.891-2.493Zm7.565-1.272a2.188 2.188 0 0 0-.873-.873 2.362 2.362 0 0 0-1.235-.321c-.426 0-.796.09-1.103.272-.16.098-.3.217-.425.364-.112.132-.21.286-.287.46-.16.37-.244.846-.244 1.419 0 .572.084 1.04.258 1.417.091.196.203.364.336.504.111.125.244.237.39.32.307.182.67.273 1.075.273.46 0 .872-.098 1.235-.307.37-.203.663-.496.873-.873.216-.37.328-.818.328-1.334 0-.517-.112-.95-.328-1.32Zm-1.278 2.047a1.2 1.2 0 0 1-.446.468c-.182.105-.39.16-.628.16a1.28 1.28 0 0 1-.635-.16 1.138 1.138 0 0 1-.44-.468 1.49 1.49 0 0 1-.167-.727c0-.279.055-.523.167-.726.105-.195.251-.35.44-.461.188-.112.404-.16.635-.16a1.187 1.187 0 0 1 1.075.621c.111.203.167.447.167.727 0 .279-.056.523-.168.726Zm-2.386-.712.028-1.453v-1h-1.354v6.644h1.416v-2.753l-.09-1.439Zm4.94-4.31v6.74h1.41v-6.74h-1.41Zm7.384 2.99a2.373 2.373 0 0 0-.956-.88 2.882 2.882 0 0 0-1.381-.33c-.517 0-.977.113-1.382.33a2.44 2.44 0 0 0-.956.886c-.23.378-.342.81-.342 1.3 0 .489.111.922.342 1.299.237.377.55.67.956.894.404.216.865.321 1.382.321.516 0 .977-.105 1.381-.321.405-.224.726-.517.956-.894a2.5 2.5 0 0 0 .342-1.3c0-.488-.118-.928-.342-1.306Zm-1.256 2.032a1.15 1.15 0 0 1-.446.468c-.182.105-.398.16-.635.16a1.28 1.28 0 0 1-.636-.16 1.327 1.327 0 0 1-.453-.468 1.571 1.571 0 0 1-.16-.727c0-.279.055-.523.16-.726.118-.195.272-.35.453-.461.189-.112.405-.16.636-.16a1.178 1.178 0 0 1 1.081.622c.112.202.168.446.168.725 0 .28-.056.524-.168.727Zm4.404-2.969a1.46 1.46 0 0 0-.51.454v-.65h-1.353v4.883h1.416v-2.305c0-.468.119-.81.356-1.027.244-.223.559-.335.942-.335.056 0 .105 0 .154.007.049 0 .105.007.167.007V60.57c-.46 0-.851.09-1.172.272Zm6.42.908a2.287 2.287 0 0 0-.914-.873 2.71 2.71 0 0 0-1.291-.307c-.481 0-.935.112-1.333.328-.391.21-.705.51-.935.887-.223.378-.335.81-.335 1.3 0 .489.119.922.349 1.299.23.377.551.67.97.894.419.216.914.321 1.466.321a3.2 3.2 0 0 0 1.172-.195c.342-.14.621-.336.845-.594l-.754-.817c-.161.16-.342.279-.545.356a1.837 1.837 0 0 1-.683.119c-.287 0-.545-.05-.761-.154a1.262 1.262 0 0 1-.496-.461 1.336 1.336 0 0 1-.139-.37h3.692a4.86 4.86 0 0 0 .02-.189c.007-.07.007-.133.007-.188 0-.524-.111-.979-.335-1.356Zm-3.398.908c.021-.146.063-.286.132-.405.105-.195.245-.342.426-.447.189-.111.405-.16.649-.16a1.177 1.177 0 0 1 1.061.593c.063.126.112.266.133.42h-2.401Z"
        fill="#333"
      />
      <path
        d="M62.363 84.39H33.052v2.794h29.311V84.39ZM47.01 61.338H33.052v4.191H47.01v-4.191Z"
        fill="#D9D9D9"
      />
      <path d="M62.363 68.323H33.052v4.191h29.311v-4.19Z" fill="#fff" />
      <path
        d="M62.363 92.772H33.052v2.794h29.311v-2.794ZM62.363 101.154H33.052v2.794h29.311v-2.794Z"
        fill="#D9D9D9"
      />
      <path
        d="M76.321 93.121h130.505M76.321 101.503h130.505M76.321 109.886h130.505M76.321 118.268h130.505M76.321 126.65h130.505M76.321 135.033h130.505M76.321 143.416h130.505M76.321 151.798h130.505M76.321 160.18h130.505M76.321 168.562h130.505"
        stroke="#EBEBEB"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h266v222H0z" />
      </clipPath>
      <filter
        id="b"
        x={13.121}
        y={7.657}
        width={241.793}
        height={215.281}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={7} dy={7} />
        <feGaussianBlur stdDeviation={5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4352_39126" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_4352_39126" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const HEADING_TO_EXPLORE_ICON = (
  <svg
    width="252"
    height="137"
    viewBox="0 0 252 137"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8020_47265)">
      <g clipPath="url(#clip1_8020_47265)">
        <g opacity="0.62">
          <path
            opacity="0.62"
            d="M248.076 2.57925C248.076 3.32592 248.722 3.93383 249.532 3.93383C250.335 3.93383 250.993 3.33253 251 2.59247C251 1.8458 250.355 1.23788 249.545 1.23788C248.741 1.23788 248.083 1.83919 248.083 2.57925H248.076Z"
            fill="#80CE9D"
          />
          <path
            opacity="0.62"
            d="M247.997 22.1051C247.997 22.8517 248.642 23.4597 249.452 23.4597C250.256 23.4597 250.914 22.8583 250.921 22.1183C250.921 21.3716 250.269 20.7637 249.466 20.7637C248.662 20.7637 248.004 21.365 248.004 22.1051H247.997Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M247.918 41.6309C247.918 42.3776 248.563 42.9855 249.373 42.9855C250.177 42.9855 250.835 42.3842 250.835 41.6441C250.835 40.8974 250.19 40.2895 249.38 40.2895C248.577 40.2895 247.918 40.8908 247.911 41.6309H247.918Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M249.294 62.5113C248.906 62.5113 248.537 62.3659 248.261 62.1148C247.991 61.8637 247.839 61.5135 247.839 61.1567C247.839 60.9783 247.879 60.8065 247.951 60.6413C248.023 60.4761 248.135 60.3307 248.267 60.2052C248.405 60.0796 248.563 59.9805 248.741 59.9145C248.919 59.8484 249.11 59.8153 249.301 59.8153C249.69 59.8153 250.058 59.9607 250.328 60.2118C250.598 60.4629 250.756 60.8065 250.756 61.1633C250.756 61.5201 250.598 61.8637 250.328 62.1148C250.052 62.3659 249.683 62.5047 249.294 62.5047V62.5113Z"
            fill="#80CE9D"
          />
          <path
            opacity="0.62"
            d="M247.76 80.6891C247.76 81.4358 248.405 82.0437 249.215 82.0437C250.025 82.0437 250.677 81.4424 250.684 80.7023C250.684 79.9557 250.039 79.3477 249.229 79.3477C248.425 79.3477 247.767 79.9424 247.76 80.6891Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M247.681 100.222C247.681 100.968 248.326 101.576 249.136 101.576C249.94 101.576 250.598 100.975 250.605 100.235C250.605 99.4881 249.959 98.8802 249.149 98.8802C248.346 98.8802 247.687 99.4815 247.681 100.222Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M247.602 119.747C247.602 120.494 248.247 121.102 249.057 121.102C249.861 121.102 250.519 120.501 250.526 119.761C250.526 119.014 249.881 118.406 249.071 118.406C248.267 118.406 247.609 119.007 247.602 119.747Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M233.885 2.51977C233.885 3.26645 234.53 3.87436 235.34 3.87436C236.144 3.87436 236.802 3.27305 236.809 2.53299C236.809 1.78632 236.163 1.17841 235.353 1.17841C234.55 1.17841 233.891 1.77971 233.891 2.51977H233.885Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M233.806 22.0456C233.806 22.7923 234.451 23.4002 235.261 23.4002C236.071 23.4002 236.723 22.7989 236.73 22.0588C236.73 21.3121 236.084 20.7042 235.274 20.7042C234.471 20.7042 233.812 21.3055 233.812 22.0456H233.806Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M233.727 41.5714C233.727 42.3181 234.372 42.926 235.182 42.926C235.985 42.926 236.644 42.3247 236.65 41.5846C236.65 40.838 236.005 40.23 235.195 40.23C234.385 40.23 233.733 40.8313 233.727 41.5714Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M235.103 62.4518C234.714 62.4518 234.346 62.3064 234.069 62.0553C233.799 61.8043 233.641 61.454 233.648 61.0972C233.648 60.9188 233.687 60.747 233.76 60.5818C233.832 60.4166 233.944 60.2713 234.076 60.1457C234.214 60.0202 234.372 59.9211 234.55 59.855C234.728 59.7889 234.919 59.7559 235.11 59.7559C235.301 59.7559 235.492 59.7889 235.669 59.8616C235.847 59.9277 236.005 60.0268 236.144 60.1523C236.282 60.2779 236.387 60.4298 236.46 60.5884C236.532 60.7536 236.572 60.9254 236.572 61.1038C236.572 61.4607 236.414 61.8043 236.144 62.0553C235.867 62.3064 235.498 62.4452 235.11 62.4452L235.103 62.4518Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M233.569 80.6297C233.569 81.3763 234.214 81.9842 235.024 81.9842C235.827 81.9842 236.486 81.3896 236.492 80.6429C236.492 79.8962 235.847 79.2883 235.037 79.2883C234.234 79.2883 233.575 79.883 233.575 80.6297H233.569Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M233.49 100.162C233.49 100.909 234.135 101.517 234.945 101.517C235.749 101.517 236.407 100.915 236.407 100.175C236.407 99.4286 235.762 98.8207 234.952 98.8207C234.142 98.8207 233.49 99.422 233.483 100.162H233.49Z"
            fill="#80CE9D"
          />
          <path
            opacity="0.62"
            d="M233.411 119.688C233.411 120.435 234.056 121.042 234.866 121.042C235.676 121.042 236.328 120.441 236.335 119.701C236.335 118.954 235.689 118.346 234.879 118.346C234.076 118.346 233.417 118.948 233.411 119.688Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M219.687 2.46029C219.687 3.20697 220.332 3.81488 221.142 3.81488C221.946 3.81488 222.604 3.21357 222.604 2.47351C222.604 1.72684 221.959 1.11893 221.149 1.11893C220.339 1.11893 219.687 1.72023 219.68 2.46029H219.687Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M219.608 21.9861C219.608 22.7328 220.253 23.3407 221.063 23.3407C221.873 23.3407 222.525 22.7394 222.532 21.9993C222.532 21.2527 221.886 20.6447 221.076 20.6447C220.273 20.6447 219.614 21.246 219.614 21.9861H219.608Z"
            fill="#80CE9D"
          />
          <path
            opacity="0.62"
            d="M41.5139 5.5263C41.5139 6.27298 42.1593 6.88089 42.9693 6.88089C43.7727 6.88089 44.4312 6.27958 44.4312 5.53952C44.4312 4.79285 43.7859 4.18494 42.9759 4.18494C42.1725 4.18494 41.5139 4.78624 41.5139 5.5263Z"
            fill="#80CE9D"
          />
          <path
            opacity="0.62"
            d="M219.529 41.5119C219.529 42.2586 220.174 42.8665 220.984 42.8665C221.787 42.8665 222.446 42.2652 222.452 41.5251C222.452 40.7785 221.807 40.1706 220.997 40.1706C220.194 40.1706 219.535 40.7719 219.529 41.5119Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M220.905 62.399C220.517 62.399 220.148 62.2536 219.871 62.0025C219.601 61.7514 219.45 61.4012 219.45 61.0444C219.45 60.6876 219.608 60.344 219.884 60.0929C220.161 59.8418 220.53 59.703 220.918 59.703C221.109 59.703 221.3 59.736 221.478 59.8087C221.656 59.8748 221.814 59.9739 221.952 60.0995C222.09 60.225 222.196 60.377 222.268 60.5356C222.341 60.7008 222.38 60.8726 222.38 61.051C222.38 61.4078 222.222 61.7514 221.952 62.0025C221.682 62.2536 221.307 62.3924 220.918 62.3924L220.905 62.399Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M219.371 80.5702C219.371 81.3169 220.016 81.9248 220.826 81.9248C221.636 81.9248 222.288 81.3235 222.294 80.5834C222.294 79.8367 221.649 79.2288 220.839 79.2288C220.036 79.2288 219.377 79.8235 219.371 80.5702Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M219.292 100.103C219.292 100.849 219.937 101.457 220.747 101.457C221.557 101.457 222.209 100.862 222.215 100.116C222.215 99.3691 221.57 98.7612 220.76 98.7612C219.95 98.7612 219.298 99.3625 219.292 100.103Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M219.213 119.628C219.213 120.375 219.858 120.983 220.668 120.983C221.471 120.983 222.13 120.382 222.137 119.642C222.137 118.895 221.491 118.287 220.681 118.287C219.878 118.287 219.219 118.888 219.219 119.628H219.213Z"
            fill="#80CE9D"
          />
          <path
            opacity="0.62"
            d="M205.495 2.40085C205.495 3.14752 206.141 3.75543 206.951 3.75543C207.754 3.75543 208.413 3.15413 208.413 2.41406C208.413 1.66739 207.767 1.05948 206.957 1.05948C206.147 1.05948 205.495 1.66078 205.489 2.40085H205.495Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M205.416 21.9267C205.416 22.6733 206.062 23.2812 206.872 23.2812C207.675 23.2812 208.334 22.6799 208.334 21.9399C208.334 21.1932 207.688 20.5853 206.878 20.5853C206.075 20.5853 205.416 21.1866 205.41 21.9267H205.416Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M205.337 41.4591C205.337 42.2057 205.983 42.8137 206.793 42.8137C207.603 42.8137 208.255 42.2124 208.261 41.4723C208.261 40.7256 207.616 40.1177 206.806 40.1177C206.003 40.1177 205.344 40.719 205.337 41.4591Z"
            fill="#80CE9D"
          />
          <path
            opacity="0.62"
            d="M27.2434 24.9992C27.2434 25.7459 27.8888 26.3538 28.6988 26.3538C29.5022 26.3538 30.1607 25.7525 30.1607 25.0124C30.1607 24.2658 29.5153 23.6579 28.7054 23.6579C27.9019 23.6579 27.2434 24.2592 27.2434 24.9992Z"
            fill="#80CE9D"
          />
          <path
            opacity="0.62"
            d="M206.72 62.3395C206.529 62.3395 206.338 62.2998 206.16 62.2338C205.983 62.1677 205.825 62.062 205.693 61.9364C205.555 61.8109 205.449 61.6589 205.377 61.5003C205.304 61.3351 205.265 61.1633 205.271 60.9849C205.271 60.6281 205.43 60.2845 205.7 60.0334C205.976 59.7823 206.345 59.6435 206.727 59.6435C206.918 59.6435 207.109 59.6766 207.287 59.7493C207.464 59.8153 207.622 59.9144 207.761 60.04C207.892 60.1655 208.004 60.3175 208.077 60.4761C208.149 60.6413 208.189 60.8131 208.189 60.9915C208.189 61.3483 208.031 61.6919 207.761 61.943C207.484 62.1941 207.115 62.3329 206.727 62.3329L206.72 62.3395Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M205.179 80.5107C205.179 81.2574 205.825 81.8653 206.635 81.8653C207.438 81.8653 208.097 81.264 208.103 80.524C208.11 79.7839 207.458 79.1694 206.648 79.1694C205.844 79.1694 205.186 79.7707 205.179 80.5107Z"
            fill="#80CE9D"
          />
          <path
            opacity="0.62"
            d="M205.1 100.043C205.1 100.79 205.746 101.398 206.556 101.398C207.366 101.398 208.018 100.803 208.018 100.056C208.018 99.3097 207.372 98.7018 206.562 98.7018C205.759 98.7018 205.1 99.2964 205.094 100.043H205.1Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M205.021 119.569C205.021 120.316 205.667 120.924 206.477 120.924C207.28 120.924 207.939 120.322 207.945 119.582C207.945 118.836 207.3 118.228 206.49 118.228C205.686 118.228 205.028 118.829 205.028 119.569H205.021Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M0 39.2719C0 40.0186 0.645363 40.6265 1.45536 40.6265C2.25877 40.6265 2.9173 40.0252 2.9173 39.2851C2.9173 38.5385 2.27194 37.9306 1.46194 37.9306C0.658533 37.924 0 38.5253 0 39.2719Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M191.304 2.34137C191.304 3.08804 191.949 3.69595 192.759 3.69595C193.563 3.69595 194.221 3.09465 194.221 2.35458C194.221 1.60791 193.576 1 192.766 1C191.956 1 191.304 1.6013 191.297 2.34137H191.304Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M191.225 21.8738C191.225 22.6205 191.87 23.2284 192.68 23.2284C193.484 23.2284 194.142 22.6271 194.149 21.887C194.149 21.1403 193.503 20.5324 192.693 20.5324C191.883 20.5324 191.231 21.1337 191.225 21.8738Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M191.146 41.3996C191.146 42.1463 191.791 42.7542 192.601 42.7542C193.411 42.7542 194.063 42.1529 194.063 41.4128C194.063 40.6661 193.418 40.0582 192.608 40.0582C191.805 40.0582 191.146 40.6595 191.146 41.3996Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M192.516 62.28C192.127 62.28 191.758 62.1347 191.482 61.8836C191.212 61.6325 191.054 61.2823 191.06 60.9254C191.06 60.747 191.1 60.5752 191.172 60.41C191.245 60.2448 191.357 60.0995 191.488 59.9739C191.627 59.8484 191.785 59.7493 191.962 59.6832C192.14 59.6171 192.331 59.5841 192.522 59.5841C192.911 59.5841 193.28 59.7294 193.55 59.9805C193.82 60.2316 193.971 60.5752 193.971 60.932C193.971 61.1105 193.931 61.2823 193.859 61.4475C193.787 61.6126 193.681 61.758 193.543 61.8836C193.405 62.0091 193.247 62.1082 193.069 62.1743C192.891 62.2404 192.7 62.2734 192.509 62.2734L192.516 62.28Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M190.981 80.4579C190.981 81.2045 191.627 81.8124 192.437 81.8124C193.24 81.8124 193.898 81.2111 193.898 80.4711C193.898 79.7244 193.253 79.1165 192.443 79.1165C191.64 79.1165 190.981 79.7178 190.975 80.4579H190.981Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M190.902 99.9837C190.902 100.73 191.548 101.338 192.358 101.338C193.161 101.338 193.82 100.744 193.82 99.9969C193.82 99.2502 193.174 98.6423 192.364 98.6423C191.554 98.6423 190.902 99.237 190.896 99.9837H190.902Z"
            fill="#FF9B00"
          />
          <path
            opacity="0.62"
            d="M190.823 119.516C190.823 120.263 191.469 120.871 192.279 120.871C193.082 120.871 193.741 120.276 193.747 119.529C193.747 118.783 193.102 118.175 192.292 118.175C191.488 118.175 190.83 118.776 190.83 119.516H190.823Z"
            fill="#FF9B00"
          />
        </g>
        <g filter="url(#filter0_d_8020_47265)">
          <path
            d="M221.195 137.932C220.885 138.797 220.556 139.637 220.207 140.463C218.521 144.467 216.394 148.009 213.958 151.114C212.219 153.321 210.039 155.561 207.464 157.795C207.109 158.112 206.74 158.422 206.365 158.74C206.022 159.024 205.667 159.314 205.311 159.599C202.427 161.924 199.134 164.237 195.499 166.504C194.491 167.138 193.464 167.759 192.404 168.38C160.076 187.364 104.529 202.469 64.1214 192.796C48.2969 189.003 34.7969 181.411 25.9265 168.763C24.7148 167.039 23.5953 165.222 22.5614 163.305C17.3392 153.612 15.2122 145.722 15.2122 138.857C15.2122 128.76 19.8087 120.857 25.9265 112.624C29.0677 108.395 32.6106 104.074 36.1404 99.3295C36.7857 98.4639 37.4311 97.5851 38.0699 96.6864C39.2816 94.9882 40.4867 93.2306 41.6589 91.4002C42.212 90.5346 42.7652 89.6558 43.3052 88.7571C44.3193 87.059 45.3137 85.3013 46.2554 83.471C46.7098 82.6054 47.1444 81.7265 47.5725 80.8279C48.4681 78.9579 49.311 77.0152 50.1013 74.9867C50.4569 73.1497 50.8652 71.3524 51.3393 69.5947C51.6883 68.2534 52.0769 66.9318 52.4917 65.6301C54.4937 59.3726 57.1937 53.6437 60.4732 48.45C60.4929 48.4104 60.5193 48.3707 60.5456 48.3377C90.8052 0.47137 169.605 -2.05938 198.943 45.318C199.569 46.329 200.188 47.3399 200.787 48.3377C202.789 51.668 204.646 54.919 206.365 58.0973C206.661 58.6458 206.951 59.1876 207.24 59.7294C207.537 60.2911 207.833 60.8461 208.116 61.4012C225.805 95.4309 227.411 120.613 221.195 137.932Z"
            fill="#45D09C"
          />
        </g>
        <path d="M206.358 48.3311H25.9199V156.704H206.358V48.3311Z" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M206.365 48.338V158.74C206.022 159.024 205.667 159.315 205.311 159.599C202.427 161.925 199.134 164.237 195.499 166.504C194.492 167.138 193.464 167.759 192.404 168.38C160.077 187.364 104.529 202.47 64.1217 192.796C48.2971 189.003 34.7972 181.411 25.9268 168.764V96.1911C27.7707 94.6713 29.6277 93.0855 31.4453 91.4005C32.3738 90.5481 33.2892 89.6693 34.1914 88.7574C35.8113 87.1121 37.3918 85.3611 38.8867 83.4712C39.5584 82.6188 40.2169 81.74 40.8557 80.8282C43.1474 77.5507 45.1691 73.8834 46.7628 69.6809C46.7759 69.6545 46.7825 69.6215 46.7957 69.595C47.2962 68.2801 47.7769 66.9585 48.2445 65.6304C49.9303 60.8596 51.4383 56.0624 52.9332 51.2982C53.2361 50.3467 53.5325 49.3952 53.8354 48.4503C53.842 48.4107 53.8552 48.3776 53.8683 48.338H206.365Z"
          fill="white"
        />
        <path
          d="M64.1215 48.45V192.796C48.2969 189.003 34.797 181.411 25.9265 168.763V48.45H64.1215Z"
          fill="#002A28"
        />
        <path d="M195.821 74.2202H72.0171V81.4886H195.821V74.2202Z" fill="#D6D6D6" />
        <path
          d="M195.499 81.819V166.504C194.491 167.138 193.464 167.759 192.404 168.38H72.353V81.819H195.499Z"
          stroke="#D6D6D6"
        />
        <path
          d="M74.0061 59.3991V60.4761H76.8905V59.3991H74.0061ZM74.1114 61.8703V58.0907H77.2592V56.974H72.7351V62.987H77.3712V61.8703H74.1114ZM80.9931 60.6281L82.7053 58.3682H81.2829L80.2819 59.7162L79.3073 58.3682H77.8124L79.5246 60.6545L77.7531 62.987H79.2085L80.249 61.5664L81.2631 62.987H82.7777L80.9931 60.6281ZM88.1316 59.4255C87.9341 59.0687 87.6575 58.7911 87.3085 58.5995C86.966 58.3947 86.5775 58.2956 86.1428 58.2956C85.7411 58.2956 85.3921 58.3815 85.1024 58.5533C84.9509 58.6458 84.8192 58.7581 84.7007 58.8969C84.5953 59.0224 84.5031 59.1678 84.4307 59.333C84.2792 59.6832 84.2002 60.1325 84.2002 60.6743C84.2002 61.2162 84.2792 61.6589 84.4438 62.0157C84.5294 62.2007 84.6348 62.3593 84.7599 62.4915C84.8653 62.6104 84.9904 62.7161 85.1287 62.7954C85.4185 62.9672 85.7609 63.0531 86.1428 63.0531C86.5775 63.0531 86.966 62.9606 87.3085 62.7624C87.6575 62.5708 87.9341 62.2932 88.1316 61.9364C88.3358 61.5862 88.4411 61.1633 88.4411 60.6743C88.4411 60.1854 88.3358 59.7757 88.1316 59.4255V59.4255ZM86.9265 61.3615C86.8211 61.5532 86.6828 61.6985 86.505 61.8043C86.3338 61.9034 86.1363 61.9562 85.9124 61.9562C85.6885 61.9562 85.4909 61.9034 85.3131 61.8043C85.1353 61.6985 84.997 61.5532 84.8982 61.3615C84.7929 61.1699 84.7402 60.9386 84.7402 60.6743C84.7402 60.41 84.7929 60.1788 84.8982 59.9871C84.997 59.8021 85.1353 59.6568 85.3131 59.551C85.4909 59.4453 85.695 59.3991 85.9124 59.3991C86.1297 59.3991 86.3338 59.4453 86.505 59.551C86.6828 59.6568 86.8211 59.8021 86.9265 59.9871C87.0319 60.1788 87.0846 60.41 87.0846 60.6743C87.0846 60.9386 87.0319 61.1699 86.9265 61.3615ZM84.6743 60.6876L84.7007 59.3132V58.3682H83.4231V64.6522H84.7599V62.0487L84.6743 60.6876ZM89.3367 56.6106V62.987H90.667V56.6106H89.3367ZM96.304 59.4387C96.0867 59.0819 95.7838 58.8044 95.4018 58.6061C95.0199 58.4013 94.5852 58.2956 94.0979 58.2956C93.6106 58.2956 93.176 58.4013 92.794 58.6061C92.4121 58.8044 92.1157 59.0885 91.8918 59.4453C91.6745 59.8021 91.5692 60.2118 91.5692 60.6743C91.5692 61.1369 91.6745 61.5466 91.8918 61.9034C92.1157 62.2602 92.4121 62.5377 92.794 62.7492C93.176 62.954 93.6106 63.0531 94.0979 63.0531C94.5852 63.0531 95.0199 62.954 95.4018 62.7492C95.7838 62.5377 96.0867 62.2602 96.304 61.9034C96.5148 61.5466 96.6267 61.1369 96.6267 60.6743C96.6267 60.2118 96.5148 59.7955 96.304 59.4387V59.4387ZM95.1187 61.3615C95.0199 61.5532 94.875 61.6985 94.6972 61.8043C94.526 61.9034 94.3218 61.9562 94.0979 61.9562C93.874 61.9562 93.6765 61.9034 93.4987 61.8043C93.3274 61.6985 93.1826 61.5532 93.0706 61.3615C92.9718 61.1699 92.9192 60.9386 92.9192 60.6743C92.9192 60.41 92.9718 60.1788 93.0706 59.9871C93.1826 59.8021 93.3274 59.6568 93.4987 59.551C93.6765 59.4453 93.8806 59.3991 94.0979 59.3991C94.3152 59.3991 94.526 59.4453 94.6972 59.551C94.875 59.6568 95.0199 59.8021 95.1187 59.9871C95.224 60.1788 95.2767 60.41 95.2767 60.6743C95.2767 60.9386 95.224 61.1699 95.1187 61.3615ZM99.274 58.5533C99.0764 58.659 98.9184 58.8044 98.7933 58.9828V58.3682H97.5157V62.987H98.8525V60.8065C98.8525 60.3638 98.9645 60.04 99.1884 59.8352C99.4189 59.6237 99.7152 59.518 100.077 59.518C100.13 59.518 100.176 59.518 100.222 59.5246C100.268 59.5246 100.321 59.5312 100.38 59.5312V58.2956C99.9457 58.2956 99.5769 58.3815 99.274 58.5533ZM105.333 59.4123C105.122 59.0555 104.832 58.7779 104.47 58.5863C104.108 58.3947 103.706 58.2956 103.252 58.2956C102.797 58.2956 102.369 58.4013 101.994 58.6061C101.625 58.8044 101.329 59.0885 101.111 59.4453C100.901 59.8021 100.795 60.2118 100.795 60.6743C100.795 61.1369 100.907 61.5466 101.124 61.9034C101.342 62.2602 101.645 62.5377 102.04 62.7492C102.435 62.954 102.903 63.0531 103.423 63.0531C103.844 63.0531 104.206 62.9937 104.529 62.8681C104.852 62.7359 105.115 62.5509 105.326 62.3064L104.615 61.5333C104.463 61.6853 104.292 61.7977 104.101 61.8703C103.917 61.943 103.706 61.9827 103.456 61.9827C103.186 61.9827 102.942 61.9364 102.738 61.8373C102.54 61.7316 102.382 61.5862 102.27 61.4012C102.211 61.2955 102.165 61.1765 102.139 61.051H105.622C105.629 60.9981 105.635 60.9387 105.642 60.8726C105.649 60.8065 105.649 60.747 105.649 60.6942C105.649 60.1986 105.543 59.7691 105.333 59.4123V59.4123ZM102.125 60.2713C102.145 60.1325 102.185 60.0004 102.251 59.888C102.349 59.703 102.481 59.5642 102.652 59.4651C102.83 59.3594 103.034 59.3132 103.265 59.3132C103.495 59.3132 103.693 59.3594 103.864 59.4651C104.035 59.5642 104.167 59.703 104.266 59.8748C104.325 59.9937 104.371 60.1259 104.391 60.2713H102.125V60.2713Z"
          fill="#333333"
        />
        <path d="M58.8466 80.8279H31.1882V83.471H58.8466V80.8279Z" fill="#D9D9D9" />
        <path d="M44.3589 59.0224H31.1882V62.987H44.3589V59.0224Z" fill="#D9D9D9" />
        <path d="M58.8466 65.6301H31.1882V69.5948H58.8466V65.6301Z" fill="white" />
        <path d="M58.8466 88.7571H31.1882V91.4002H58.8466V88.7571Z" fill="#D9D9D9" />
        <path d="M58.8466 96.6864H31.1882V99.3295H58.8466V96.6864Z" fill="#D9D9D9" />
        <path d="M72.0171 89.0875H195.163" stroke="#EBEBEB" />
        <path d="M72.0171 97.0168H195.163" stroke="#EBEBEB" />
        <path d="M72.0171 104.946H195.163" stroke="#EBEBEB" />
        <path d="M72.0171 112.875H195.163" stroke="#EBEBEB" />
        <path d="M72.0171 120.805H195.163" stroke="#EBEBEB" />
        <path d="M72.0171 128.734H195.163" stroke="#EBEBEB" />
        <path d="M72.0171 136.663H195.163" stroke="#EBEBEB" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_8020_47265"
        x="12.2122"
        y="8.08115"
        width="229.286"
        height="204.726"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="7" dy="7" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8020_47265" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8020_47265"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_8020_47265">
        <rect width="252" height="137" fill="white" />
      </clipPath>
      <clipPath id="clip1_8020_47265">
        <rect width="251" height="210" fill="white" transform="translate(0 1)" />
      </clipPath>
    </defs>
  </svg>
);
